export enum RulesIconKey {
    NO_SMOKING = 'no-smoking',
    NO_PETS = 'no-pets',
    NO_PARTIES = 'no-parties',
    VOLUME_X = 'volume-x',
    ALERT_TRIANGLE = 'alert-triangle',
    USER = 'user',
    ALLOWS_PETS = 'allows-pets',
    DEFAULT = 'default',
}
